import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";

const normalizeImageUrl = (url) => encodeURI(url || '');

const getLogoLabel = (url) => {
    const parts = (url || '').split('/');
    const fileName = parts[parts.length - 1] || 'Partner';
    return decodeURIComponent(fileName)
        .replace(/\.[a-z0-9]+$/i, '')
        .replace(/[-_]+/g, ' ')
        .trim();
};

const Carusel = (props) => {
    const _responsive = {
        0: { items: 1 },
        600: { items: 2 },
        1024: { items: 3 },
    };

    return (
        <div className="bgg-sponsors-wrap">
        <AliceCarousel
            duration={400}
            autoPlay={true}
            startIndex={1}
            fadeOutAnimation={true}
            mouseDragEnabled={true}
            autoPlayInterval={2600}
            autoPlayDirection="rtl"
            responsive={_responsive}
            style={{
                height: "200px"
            }}
        >
            {props.imgs.map((_prop, key) => (
                <div key={key} className="bgg-sponsor-logo">
                    <img
                        className="d-block"
                        src={normalizeImageUrl(_prop)}
                        alt={getLogoLabel(_prop)}
                        decoding="async"
                        referrerPolicy="no-referrer"
                        onError={(event) => {
                            event.currentTarget.style.display = 'none';
                            if (event.currentTarget.nextSibling) {
                                event.currentTarget.nextSibling.style.display = 'flex';
                            }
                        }}
                    />
                    <span className="bgg-sponsor-fallback">
                        {getLogoLabel(_prop)}
                    </span>
                </div>
            ))
            }

        </AliceCarousel>
        </div>
    )
}

export default Carusel;



// WEBPACK FOOTER //
// ./src/components/Carusel/Carusel.jsx